export default __webpack_public_path__ + "static/media/4.43df440d.jpg";